import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
	{
	  path: '/about',
	  name: 'About',
	  component: () => import('../views/about.vue')
	},
	{
		path: '/contact',
		name: 'Contact',
		component: () => import('../views/contact.vue')
	},
	{
		path: '/product',
		name: 'Product',
		component: () => import('../views/product.vue')
	},
	{
		path: '/pptOne',
		name: 'PptOne',
		component: () => import('../views/ppt/ppt-one.vue')
	},
	{
		path: '/pptTwo',
		name: 'PptTwo',
		component: () => import('../views/ppt/ppt-two.vue')
	},
	{
		path: '/pptThree',
		name: 'PptThree',
		component: () => import('../views/ppt/ppt-three.vue')
	},
	{
		path: '/pptFour',
		name: 'PptFour',
		component: () => import('../views/ppt/ppt-four.vue')
	},
	{
		path: '/pptFive',
		name: 'PptFive',
		component: () => import('../views/ppt/ppt-five.vue')
	}
]

const router = new VueRouter({
  mode:'history',
  routes
})

export default router
